import { Box, Typography } from '@mui/material';
import React from 'react';

import { AppPromotion, Button, Modal } from '@/components';
import { COLOR } from '@/theme/colors';

import { Props } from './types';

const UnlockPremiumModal: React.FC<Props> = ({
    close,
    color,
    title,
    description,
    logo,
}) => {
    return (
        <Modal isOpen center styles="p-5 max-w-[558px]">
            <Box className="flex justify-between gap-[72px] w-full">
                <Box className="flex flex-col gap-5 items-center mt-6">
                    <Box className="flex justify-center items-center w-full">
                        {logo}
                    </Box>
                    <Typography
                        className="text-center"
                        fontWeight={700}
                        fontSize={20}
                        lineHeight="24px"
                        sx={{ whiteSpace: 'pre-line', px: '20px' }}
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                    <Box className="px-[14px] py-[17px] rounded-lg bg-alabaster w-full">
                        <Typography
                            fontSize={11}
                            lineHeight="15px"
                            color={COLOR.nevada}
                            sx={{ whiteSpace: 'pre-line' }}
                        >
                            {description}
                        </Typography>
                    </Box>
                </Box>

                <AppPromotion />
            </Box>

            <Button
                sx={{
                    backgroundColor: color,
                    color: COLOR.white,
                    mt: '24px',
                    '&:hover': {
                        backgroundColor: color,
                        opacity: 0.8,
                    },
                }}
                caption="Got it"
                onClick={close}
            />
        </Modal>
    );
};

export default UnlockPremiumModal;
